
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/howItWorks",
      function () {
        return require("private-next-pages/howItWorks/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/howItWorks"])
      });
    }
  